const state = () => ({
    modal: null,
    videoUrl: null,
});

const mutations = {
    setModal(state, name) {
        state.modal = name;
    },

    setVideoModal(state, url) {
        state.videoUrl = url;
        state.modal = 'video-modal';
    },
};

export default {
    namespaced: true,
    mutations,
    state,
};
